function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.337 1.5c1.82 0 3.491 1.486 4.308 2.308.109.11.229.234.355.371.127-.137.246-.262.355-.37.817-.823 2.498-2.309 4.308-2.309 1.514 0 2.734.436 3.569 1.274.833.837 1.268 2.063 1.268 3.589 0 2.546-2.298 4.657-2.396 4.747h0l-6.972 6.834-7.244-6.853C2.802 11.014.5 8.895.5 6.363.5 4.848.938 3.62 1.775 2.78 2.61 1.942 3.827 1.5 5.337 1.5z",
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd"
});

function SvgHeartDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHeartDefault;